import React from 'react';

function Loader() {
  return (
    <div className="loader">
      <div className="loader__item" />
    </div>
  );
}

export default Loader;